// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-title-container {
  position: fixed;
  box-sizing: border-box;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background-color: white;
  z-index: 1;
  border-bottom: 5px solid #2895eb;
  padding-left: 5px;
  padding-right: 25px;

  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chat-title {
  margin-left: 30px;
  margin-right: 30px;
  width: 70%;
  bottom: 0px;
  color: rgb(63, 70, 71);
  font-weight: 600;
  font-size: 1.25rem;

  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-decoration: none;
}

.chat-title-line {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-top: 1px solid #e7e7e0;
}

.banner-container {
  grid-row: 1;
  grid-column: 1;
  align-items: center;

  padding-top: 10px;
}

.image-banner {
  width: auto;
  height: 50px;
}

.btn-lodgeit {
  display: flex;
  align-items: center;
  gap: 9px;
}

.btn-lodgeit span {
  font-size: 12px;
  font-weight: 700;
  color: #333;
}

.btn-lodgeit svg {
  height: 33px;
}

.btn-lodgeit a {
  padding-top: 9px;
}

.margin-news-btn {
  margin-left: auto !important;
  margin-right: 1rem !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/components/header/ChatTitle.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,sBAAsB;EACtB,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;;EAEnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;;EAElB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;;EAEnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B","sourcesContent":[".chat-title-container {\n  position: fixed;\n  box-sizing: border-box;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100px;\n  background-color: white;\n  z-index: 1;\n  border-bottom: 5px solid #2895eb;\n  padding-left: 5px;\n  padding-right: 25px;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.chat-title {\n  margin-left: 30px;\n  margin-right: 30px;\n  width: 70%;\n  bottom: 0px;\n  color: rgb(63, 70, 71);\n  font-weight: 600;\n  font-size: 1.25rem;\n\n  display: block;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  text-decoration: none;\n}\n\n.chat-title-line {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-top: 1px solid #e7e7e0;\n}\n\n.banner-container {\n  grid-row: 1;\n  grid-column: 1;\n  align-items: center;\n\n  padding-top: 10px;\n}\n\n.image-banner {\n  width: auto;\n  height: 50px;\n}\n\n.btn-lodgeit {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n\n.btn-lodgeit span {\n  font-size: 12px;\n  font-weight: 700;\n  color: #333;\n}\n\n.btn-lodgeit svg {\n  height: 33px;\n}\n\n.btn-lodgeit a {\n  padding-top: 9px;\n}\n\n.margin-news-btn {\n  margin-left: auto !important;\n  margin-right: 1rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
